module.exports = __webpack_public_path__ + "static/img/9.b414380.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/userMethods/9.png
// module id = 6tDV
// module chunks = 0